import { AxiosResponse } from 'axios';
import {
  LoginValidation,
  passwordValidation,
} from '../../components/Common/Validations';
import CatchBlockFunction from '../../components/hooks/CatchBlockFunction';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';
import { get, patch, post } from '../../utils/request';
import { selectForm, selectPasswordForm } from './selector';
import { actions } from './slice';
import { ILogin, IPassword } from './types';

export function* doLoginRequest(action: { payload: { callback: any } }) {
  yield delay(500);

  const form: ILogin = yield select(selectForm);
  const isValid = LoginValidation(form);
  if (!isValid) {
    return;
  }
  let data = {
    email: form.email,
    password: btoa(form.password),
  };

  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield post('auth/admin/login', data);
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield put(actions.setIsLogin(true));
    yield put(actions.setToken(response.data.data.accessToken));
    yield call(action?.payload?.callback(response.data.data.accessToken));
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetMeProfileRequest(action: {
  payload: { token: string; callback: any };
}) {
  yield delay(500);
  if (action.payload.token) {
    try {
      yield put(actions.setLoading(true));
      const response: AxiosResponse = yield call(get, '/auth/user/me');
      if (response && !response.data) {
        toast.error(response.data.message);
        return;
      }
      yield put(
        actions.setProfileData({
          name: response.data.data.name,
          email: response.data.data.email,
          _id: response.data.data._id,
          profilePic: response.data.data.profilePic,
        }),
      );
      yield put(actions.setIsLogin(true));
      yield put(actions.setLoading(true));
      yield call(action?.payload?.callback());
    } catch (error: any) {
      yield put(actions.setLoading(false));
      CatchBlockFunction(error);
    }
  } else {
    yield put(actions.setLoading(false));
    yield put(actions.setIsLogin(false));
  }
}

export function* doUpdatePasswordRequest(action: {
  payload: { callback: any };
}) {
  yield delay(500);

  const form: IPassword = yield select(selectPasswordForm);
  const isValid = passwordValidation(form);
  if (!isValid) {
    return;
  }
  let data = {
    password: btoa(form.password),
    confirmPassword: btoa(form.confirmPassword),
  };
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      patch,
      `admin/user/update/password`,
      data,
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setToken(response.data.data.accessToken));
    toast.success(response.data.message);
    yield call(action?.payload?.callback(response.data.data.accessToken));
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}

export function* AuthRepoSaga() {
  yield takeLatest(actions.doLogin, doLoginRequest);
  yield takeLatest(actions.doGetProfile, doGetMeProfileRequest);
  yield takeLatest(actions.doUpdatePassword, doUpdatePasswordRequest);
}
